var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    { attrs: { "page-name": "fees-for-weight-and-noise-master" } },
    [
      _c(
        "PageHeader",
        { attrs: { title: _vm.title } },
        [
          _c(
            "el-row",
            { staticClass: "header-button" },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "preparation",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickPreparation }
                    },
                    [_vm._v("料金マスタ準備")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "SimpleSearch",
            {
              attrs: { model: _vm.simpleSearchFormModel, category: "master" },
              on: { search: _vm.clickSearch, clear: _vm.clickClear }
            },
            [
              _c("ChargeYear", {
                ref: "childChargeYear",
                attrs: {
                  label: "料金年度",
                  prop: "charge_year",
                  searchCond: true,
                  initialize: true,
                  required: true,
                  tableType: "WEIGHT_AND_NOISE",
                  yearType: "reference",
                  mode: "this",
                  selectedIndex: "0"
                },
                model: {
                  value: _vm.simpleSearchFormModel.charge_year,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "charge_year", $$v)
                  },
                  expression: "simpleSearchFormModel.charge_year"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("Table", {
        staticClass: "fees-for-weight-and-noise-master-table",
        attrs: {
          "table-data": _vm.tableData,
          "default-sort": { prop: "landing_time", order: "ascending" },
          "multi-select": false
        },
        on: { "row-click": _vm.clickRow },
        scopedSlots: _vm._u([
          {
            key: "columns",
            fn: function() {
              return [
                _c("RouteCodeColumn"),
                _c("TextMiddleColumn", {
                  attrs: {
                    label: "ジェット区分",
                    prop: "jet_type_name",
                    "class-name": "jet-type-name"
                  }
                }),
                _c("TextMiddleColumn", {
                  attrs: { label: "有償区分", prop: "paid_type_name" }
                }),
                _c("FeeColumn", {
                  attrs: {
                    label: "適用最小重量",
                    prop: "min_weight",
                    formatter: _vm.formatterMin
                  }
                }),
                _c("FeeColumn", {
                  attrs: {
                    label: "適用最大重量",
                    prop: "max_weight",
                    formatter: _vm.formatterMax
                  }
                }),
                _c("DateTimeColumn", {
                  attrs: { label: "更新日時", prop: "updated_on" }
                }),
                _c("BlankColumn")
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("FeesForWeightAndNoiseMasterPreparationDialog", {
        attrs: { visible: _vm.preparationDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.preparationDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      }),
      _c("FeesForWeightAndNoiseRegisterMasterDialog", {
        attrs: {
          visible: _vm.registerDialogVisible,
          "current-row": _vm.currentRow
        },
        on: {
          "update:visible": function($event) {
            _vm.registerDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      }),
      _c("FeesForWeightAndNoiseEditMasterDialog", {
        attrs: {
          visible: _vm.editDialogVisible,
          "current-row": _vm.currentRow
        },
        on: {
          "update:visible": function($event) {
            _vm.editDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }